var _path, _path2;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgTxtAttachment = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2H15.414L20 6.586V20C20 21.103 19.103 22 18 22H6C4.897 22 4 21.103 4 20V4C4 2.898 4.897 2 6 2ZM14 3V8H19L14 3Z",
    fill: "#5E35B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5506 14.9975V14.3636H10.5371V14.9975H9.42383V18H8.66388V14.9975H7.5506ZM11.7498 14.3636L12.4831 15.603H12.5115L13.2484 14.3636H14.1167L13.0069 16.1818L14.1415 18H13.2573L12.5115 16.7589H12.4831L11.7374 18H10.8567L11.9949 16.1818L10.878 14.3636H11.7498ZM14.4647 14.9975V14.3636H17.4512V14.9975H16.3379V18H15.5779V14.9975H14.4647Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTxtAttachment, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/txt-attachment.fe9ecbdb.svg";
export { ForwardRef as ReactComponent };